import { SxProps, Theme, keyframes } from '@mui/material';

const centerContainer: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '80vh'
};

const innerContainer: SxProps = {
  display: 'flex',
  gap: 4
};

const leftColumn: SxProps = {
  flex: '0 0 33.33%',
  maxWidth: '33.33%'
};

const rightColumn: SxProps = {
  flex: '0 0 66.66%',
  maxWidth: '66.66%'
};

const sectionTitle: SxProps = {
  fontSize: '32px',
  fontWeight: 400,
  lineHeight: '40px',
  mb: 1
};

const sectionSubtitle: SxProps = {
  fontSize: '15px',
  lineHeight: '20px',
  color: 'customGrey.dark'
};

const sparkleAnimation = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.1) rotate(10deg);
  }
`;

const loadingCardContainer: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  mb: 4
};

const loadingCard: SxProps = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 2,
  padding: '20px 24px',
  border: '1px solid',
  borderColor: 'primary.main',
  borderRadius: '8px',
  backgroundColor: 'background.paper',
  maxWidth: '500px',
  width: '100%'
};

const animatedIconStyle: SxProps = {
  color: 'primary.main',
  fontSize: '24px',
  animation: `${sparkleAnimation} 1.5s ease-in-out infinite`
};

const launchButtonStyle: SxProps<Theme> = {
  padding: '12px 24px'
};

const loadingTitleStyle: SxProps = {
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  mb: 0.5
};

const loadingSubtitleStyle: SxProps = {
  fontSize: '14px',
  lineHeight: '20px',
  color: 'text.secondary'
};

const errorMessageText: SxProps = {
  mb: 2,
  width: '40%',
  textAlign: 'center'
};

const sentMessageContainer: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '80vh'
};

const sentMessageText: SxProps = {
  mb: 2
};

const loadingContainer: SxProps = {
  mt: 3
};

export const campaignOpeningMessagesSx = {
  centerContainer,
  innerContainer,
  leftColumn,
  rightColumn,
  sectionTitle,
  sectionSubtitle,
  loadingCardContainer,
  loadingCard,
  animatedIconStyle,
  launchButtonStyle,
  loadingTitleStyle,
  loadingSubtitleStyle,
  errorMessageText,
  sentMessageContainer,
  sentMessageText,
  loadingContainer
};
